const { AllSocialMedia } = require("../features/admin/common/Slice");

exports.APIS = {
  Auth: "/common/auth/admin-login",
  ChangePassword: "/common/auth/change-password",

  

  Masters: {
    Country: "/admin/masters/country",
    State: "/admin/masters/state",
    City: "/admin/masters/city",
    Pincode: "/admin/masters/pincode",
    Country_Initial: "/admin/masters/initial",
    Country_Code: "/admin/masters/code",
  },


  //Blogs
  Blogs: {
    Blog: "/admin/blogs/blog"
  },


  //AboutUs
  Aboutus: {
    WhyChooseUs: "/admin/aboutus/whychooseus",
    WhatOurClientSay: "/admin/aboutus/whatourclientsay",
    Testimonial: "/admin/aboutus/testimonial",
  },


  //Customizations
  Customizations: {
    AppSetup: "/admin/customizations/appsetup",
    Office_Location: "/admin/customizations/office"
  },

  

  //PrivacyPolicys
  PrivacyPolicys: {
  PrivacyPolicy: "/admin/privacypolicys/privacypolicy"
  },


  //Terms of service
  TermsOfServices: {
  TermsOfService: "/admin/termsofservices/termsofservice"
  },


  //Home page
  HomePage: {
    Counter: "/admin/homepage/counter",
    SocialMedia: "/admin/homepage/socialmedia",
    Home_Banner: "/admin/homepage/homebanner"
  },

  Contactuss: {
    ContactUs: "/admin/contactuss/contactus",
    Farmer_Dealer: "/admin/farmer-dealer/enquiry"
  },


  //Category
  Categorys: {
    Category: "/admin/categorys/category",
    Product: "/admin/categorys/product",
    Platform: "/admin/categorys/platform",
    Project: "/admin/categorys/project",
    Location: "/admin/categorys/location",
    Project_Status: "/admin/categorys/project-status",
    Key_Benefit: "/admin/categorys/key-benefit",
    Amenity: "/admin/categorys/amenity",
  },


  //Product Enquirys
  Product_Enquirys: {
    Product_Enquiry: "/admin/product_enquirys/productenquiry"
  },

  Project_Types: {
    Project_Type: "/admin/project-type",
    Enquiry_Form: "/admin/project-type/form",
  },


  // Gallery Show
  GalleryShow: {
    GalleryCategory: "/admin/galleryshow/gallerycategory",
    GalleryPhoto: "/admin/galleryshow/galleryphoto"
  },


  //gallery
  Gallerys: {
    Gallery: "/admin/gallerys/gallery",
  },


  //FAQ
  Faqs: {
    FAQ: "/admin/faqs/faq",
    FAQCategory: "/admin/faqs/faqcategory"
  },


  //common
  Commons: {
    AllCountry: "/common/masters/all-country",
    AllState: "/common/masters/all-state",
    AllCity: "/common/masters/all-city",
    AllPincode: "/common/masters/all-pincode",

    AllCountryInitial: "/common/masters/all-country-initial",
    AllCountryCode: "/common/masters/all-country-code",

  
    AllWhyChooseUs: "/common/aboutus/all-whychooseus",

    AllAppSetup: "/common/customizations/all-appsetup",


    AllBlog: "/common/blogs/all-blog",

    AllPrivacyPolicy: "/common/privacypolicys/all-privacypolicy",

    AllTermsOfService: "/common/termsofservices/all-termsofservice",

    AllContactUs: "/common/contactuss/all-contactus",

    AllCategory: "/common/categorys/all-category",

    AllProduct: "/common/categorys/all-product",

    AllPlatform: "/common/categorys/all-platform",

    AllProductEnquiry: "/common/product_enquirys/all-productenquiry",

    AllGalleryCategory: "/common/galleryshow/all-gallerycategory",

    AllGalleryPhoto: "/common/galleryshow/all-galleryphoto",

    AllWhatOurClientSay: "/common/aboutus/all-whatourclientsay",

    AllTotalEffects: "/common/dashboard/all-totaleffects",

    AllTotalProducts: "/common/dashboard/all-totalproducts",

    AllTotalEnquirys: "/common/dashboard/all-totalenquirys",

    AllTotalContacts: "/common/dashboard/all-totalcontacts",

    AllTotalProjects: "/common/dashboard/all-totalprojects",

    AllTotalEnquiries: "/common/dashboard/all-totalenquiries",

    AllFAQ: "/common/faqs/all-faq",
    AllFAQCategory: "/common/faqs/all-faqcategory",

    //new
    AllKeyBenefit: "/common/projects/all-keybenefit",
    AllAmenity: "/common/projects/all-amenity",
    AllProject: "/common/projects/all-project",
    AllLocation: "/common/projects/all-location",
    AllProjectType: "/common/projects/all-projecttype",
    AllProjectStatus: "/common/projects/all-projectstatus",
  },


  // Dashboard
  Dashboard: {
    dashboard: "/admin/dashboard/totaleffects",
  },
};
